export default __webpack_public_path__ + "static/media/picture-3.3188279f.png";